import React, { useState, useRef, useEffect } from 'react';

const ChatInput = ({ onSend, disabled = false, customization, editingContent, isEditing }) => {
  const [message, setMessage] = useState('');
  const inputRef = useRef(null);

  // Pre-populate input when entering edit mode
  useEffect(() => {
    if (isEditing && editingContent !== undefined) {
      setMessage(editingContent);
      // Focus and move cursor to end
      setTimeout(() => {
        if (inputRef.current) {
          inputRef.current.focus();
          const len = editingContent.length;
          inputRef.current.setSelectionRange(len, len);
        }
      }, 50);
    } else if (!isEditing) {
      // Clear when edit mode is cancelled
      setMessage('');
    }
  }, [isEditing, editingContent]);

  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.style.height = 'auto';
      inputRef.current.style.height = `${Math.min(inputRef.current.scrollHeight, 100)}px`;
    }
  }, [message]);

  const handleSubmit = e => {
    e.preventDefault();
    const trimmedMessage = message.trim();
    if (trimmedMessage.length > 0) {
      onSend(trimmedMessage);
      setMessage('');
    }
  };

  const handleKeyDown = e => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      handleSubmit(e);
    }
  };

  const activeColor = isEditing ? '#22c55e' : (message.trim() ? customization.senderBubbleColor : '#8696A0');

  return (
    <div className="bg-white border-t border-gray-200 p-3 flex-shrink-0">
      <form onSubmit={handleSubmit} className="flex items-end gap-2">
        <div className="flex-1 bg-gray-100 rounded-full px-4 py-2.5 flex items-center">
          <textarea
            ref={inputRef}
            value={message}
            onChange={e => setMessage(e.target.value)}
            onKeyDown={handleKeyDown}
            placeholder={isEditing ? 'Edit your message…' : 'Type a message'}
            disabled={disabled}
            rows="1"
            className="flex-1 bg-transparent resize-none focus:outline-none text-[15px] text-gray-900 placeholder-gray-400 max-h-[100px]"
          />
        </div>

        <button
          type="submit"
          disabled={!message.trim() || disabled}
          className="w-11 h-11 rounded-full flex items-center justify-center disabled:opacity-50 disabled:cursor-not-allowed transition-all shadow-md flex-shrink-0"
          style={{ backgroundColor: activeColor }}
        >
          {isEditing ? (
            // Checkmark icon for confirming edit
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M5 13l4 4L19 7" stroke="white" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          ) : (
            // Send icon
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M22 2L11 13M22 2L15 22L11 13M22 2L2 9L11 13" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          )}
        </button>
      </form>
    </div>
  );
};

export default ChatInput;